
import React from 'react'
import PageBody from "Common/Custom/PageBody";
import {HeadingOne} from "Common/Custom/HeadingOne";
import MenuListTable from './Componate/MenuListTable';

const MenuList = () => {
  return (
    <PageBody
     card={true}
     headerchildren={
        <HeadingOne>Menu List</HeadingOne>
       }>

      {/* Table section */}
      <div className="col-12">
        <MenuListTable />
      </div>
    </PageBody>
  );
};

export default MenuList;
